export interface BusinessLocationSelection {
  latitude: string;
  longitude: string;
}

export const SMCE_REGISTRATION_NUMBER_PATTERN = /^\d-\d{2}-\d{2}-\d{2}\/\d-\d{4}$/;

export function normalizeSmceRegistrationNumber(value: string | null | undefined): string {
  return `${value ?? ''}`.replace(/\D/g, '').slice(0, 12);
}

export function formatSmceRegistrationNumber(value: string | null | undefined): string {
  const digits = normalizeSmceRegistrationNumber(value);
  const groups = [1, 2, 2, 2, 1, 4];
  const separators = ['-', '-', '-', '/', '-'];
  let result = '';
  let offset = 0;

  groups.forEach((length, index) => {
    if (offset >= digits.length) {
      return;
    }
    if (index > 0) {
      result += separators[index - 1];
    }
    result += digits.slice(offset, offset + length);
    offset += length;
  });

  return result;
}

/** Typed CPD cooperative registry response (CPD-001-02) — maps cd:CooperativeProfile[0]. */
export interface GdxCooperativeProfileAddress {
  addressText?: string | null;
  /** ตำบล/แขวง (cd:Address/cd:CitySubDivision) */
  subdistrict?: string | null;
  /** อำเภอ/เขต (cd:Address/cd:City) */
  district?: string | null;
  /** จังหวัด (cd:Address/cd:CountrySubDivision) */
  province?: string | null;
}

export interface GdxCooperativeRegistryDto {
  registryNo?: string | null;
  registryNo13?: string | null;
  cooperativeName?: string | null;
  cooperativeTypeName?: string | null;
  cooperativeStatusName?: string | null;
  registryDate?: string | null;
  addressText?: string | null;
  postcode?: string | null;
  address?: GdxCooperativeProfileAddress | null;
  returnCode?: string | null;
  description?: string | null;
  [key: string]: unknown;
}
